import { NgZone, Renderer, Output, EventEmitter, AfterViewInit, Component, ElementRef, ComponentFactoryResolver, ViewContainerRef, OnInit, Input, NgModule, ViewChild, HostListener, trigger, state, animate, transition, style, ChangeDetectorRef } from '@angular/core';
import { GlobalPopupAppendDirective } from '../../shared/directives/globalPopupAppend.directive';
import { GlobalPopupAppendComponent } from '../../shared/directives/globalPopupAppend.component';
import { SmartviewComponent } from '../../bookShared/popups/smartview/smartview.component';
import { PageEnrichmentsComponent } from '../../bookShared/popups/pageEnrichments/pageEnrichments.component';
import { ShelfPouchDb } from '../../shelf/shelf.pouchdb.service';
import { MiniBookComponent } from '../../bookShared/popups/mini-book/mini-book.component';
import { ExportviewComponent } from '../../bookShared/popups/export/export.component';

@Component({
  selector: 'app-globalpopup',
  templateUrl: './globalpopup.component.html',
  styleUrls: ['./globalpopup.component.css']
})
export class GlobalpopupComponent implements OnInit {


  @Input() popupProps: any;
  temp;

  posLeft: string;
  posTop: string;
  posLeftCon: string;
  posTopCon: string;

  x: number;
  y: number;
  px: number;
  py: number;
  width: number;
  height: number;
  minArea: number;
  draggingCorner: boolean;
  draggingWindow: boolean;
  resizer: Function;
  elm;
  togglePopup = true;
  donotClosepopup = true;
  @Output() globalPopupUpdatesCalled: EventEmitter<any> = new EventEmitter<string>();

  @ViewChild(GlobalPopupAppendDirective) globalpopupHost: GlobalPopupAppendDirective;

  @HostListener('window:resize') onResize() {
    this.closeGlobalpopupOnResize();
  }


  val = { headline: 'Hiring for several positions', body: 'Submit your resume today!' }

  constructor(private zone: NgZone, private renderer: Renderer, private el: ElementRef, private viewContainerRef: ViewContainerRef, private componentFactoryResolver: ComponentFactoryResolver, private cdr: ChangeDetectorRef, public pouchservice: ShelfPouchDb) {

  }

  // @ViewChild('dynamicInsert', { read: ViewContainerRef }) dynamicInsert: ViewContainerRef;

  ngAfterViewInit() {
    // this.cdr.detectChanges();
    this.loadComponent();
    this.cdr.detectChanges();
  }
  callFromPageEnrichment(state) {
    this.globalPopupUpdatesCalled.emit(state);
  }

  loadComponent() {

    // setTimeout(() => {
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.popupProps.loadDirective);
    let viewContainerRef = this.globalpopupHost.viewContainerRef;

    viewContainerRef.clear();

    let componentRef = viewContainerRef.createComponent(componentFactory);
    (<GlobalPopupAppendComponent>componentRef.instance).data = this;
    // this.el.nativeElement.style.backgroundColor = 'yellow';

    // }, 10);

  }
  allPersons = [
    { name: 'Mahesh', age: '25' },
    { name: 'Shakti', age: '23' },
    { name: 'Krishna', age: '23' },
    { name: 'Radha', age: '21' },
  ];


  public updatedStyle: object = {};

  public styleAttr: Object = {};
  hideTargetsPopup(evt, state) {
    evt.stopPropagation();

    if (this.popupProps.isResize != true) {
      if (state) {
        this.popupProps.showPopup = false;
        this.popupProps.isDrawingSelected = false;
        this.globalPopupUpdatesCalled.emit('closed');
        this.cdr.detectChanges();
      }
    }

    if (this.popupProps.curComp.selBookDetals && this.popupProps.curComp.selBookDetals.bookCategory == 1) {
      this.saveBookChanges();
    }
  }


  saveBookChanges() {
    this.pouchservice.updateBookInfo(this.popupProps.curComp.selBookDetals,true);
  }

  closeGlobalpopupOnResize(){ 
    this.popupProps.showPopup = false;
  }

  hidepopupFromMindmap(evt) {
    // evt.stopPropagation();
    setTimeout(() => {
      this.popupProps.showPopup = false;
    }, 0);


    this.globalPopupUpdatesCalled.emit('closed');
  }


  ngOnInit() {
    document['globalPopup'] = this;
    let curEvt;

    if (this.popupProps.iconposObj && this.popupProps.iconposObj.iconPosTop && this.popupProps.iconposObj.iconPosLeft && this.popupProps.ev == '') {
      this.posTopCon = this.popupProps.iconposObj.iconPosTop;
      this.posLeftCon = this.popupProps.iconposObj.iconPosLeft;
      this.posTop = this.popupProps.iconposObj.iconPosArrowTop;
      this.posLeft = this.popupProps.iconposObj.iconPosArrowLeft;
      // setTimeout(() => {
      //   let doc: any = document.getElementsByClassName("globalpopupMain");
      //   doc[0].style.width = 0;
      // }, 0);

      return;
    }


    if (this.popupProps.ev.currentTarget) curEvt = this.popupProps.ev.currentTarget;

    else curEvt = this.popupProps.ev.srcElement;
    let curTagHgt = curEvt.clientHeight / 2;
    let curTagWdt = curEvt.clientWidth / 2;

    let coffsetL;
    let coffsetT;

    if (this.popupProps.ev.currentTarget.classList.contains('parallelogram') || this.popupProps.ev.currentTarget.classList.contains('parallelogram2')) {
      coffsetL = this.popupProps.ev.clientX - 18;
      coffsetT = this.popupProps.ev.clientY - 10;
    }
    else if (this.popupProps.ev.currentTarget.classList.contains('tabOptns')) {
      coffsetL = this.popupProps.ev.clientX - 10;
      coffsetT = this.popupProps.ev.clientY - 5;
    }
    else {
      let scrollDiv = document.getElementsByClassName('pdfBookViewCon')[0];
      coffsetL = curEvt.offsetLeft;
      coffsetT = curEvt.offsetTop;
      if (scrollDiv && scrollDiv.scrollTop && !this.popupProps.loadPagesIndexComponent) {
        coffsetT = curEvt.offsetTop - scrollDiv.scrollTop;
      }
      if (scrollDiv && scrollDiv.scrollLeft && !this.popupProps.loadPagesIndexComponent) {
        coffsetL = curEvt.offsetLeft - scrollDiv.scrollLeft;
      }
    }
    if (this.popupProps.bookDetals) {
      coffsetL = this.popupProps.ev.clientX;
      coffsetT = this.popupProps.ev.clientY;
      curTagHgt = 0;
      if (this.popupProps.direction == 'right') {
        coffsetL = coffsetL - curTagWdt;
      }
      if (coffsetT > window.innerHeight - this.popupProps.height * 0.75) {
        var cursorPos = this.popupProps.height - (window.innerHeight - coffsetT);
        if (cursorPos > this.popupProps.height - 20) {
          cursorPos = cursorPos - 10;
        }
        this.popupProps.arrowPos = cursorPos + 10;
        console.log("update");
      }
    }
    if (window.innerWidth - this.popupProps.ev.clientX - 20 < this.popupProps.width && this.popupProps.direction == 'left') {
      this.popupProps.direction = "right";
    }
    else if (this.popupProps.ev.clientX < this.popupProps.width && this.popupProps.direction == "right") {
      this.popupProps.direction = "left";
    }


    if (this.popupProps.direction == 'left') {
      this.posLeft = coffsetL + curTagWdt * 2 - 8 + 'px';
      this.posTop = coffsetT + curTagHgt - 10 + 'px';

      this.posLeftCon = coffsetL + curTagWdt * 2 + 'px';
      this.posTopCon = coffsetT + curTagHgt - this.popupProps.arrowPos + 'px';
    }
    else if (this.popupProps.direction == 'right') {
      this.posLeft = coffsetL - 22 + 'px';
      this.posTop = coffsetT + curTagHgt - 10 + 'px';

      this.posLeftCon = coffsetL - this.popupProps.width - 10 + 'px';
      this.posTopCon = coffsetT + curTagHgt - this.popupProps.arrowPos + 'px';
    }
    else if (this.popupProps.direction == 'top') {
      this.posLeft = coffsetL + curTagWdt - 8 + 'px';
      this.posTop = coffsetT + curTagHgt * 2 + 6 + 'px';

      this.posLeftCon = coffsetL - this.popupProps.arrowPos + curTagWdt - 8 + 'px';
      this.posTopCon = coffsetT + curTagHgt * 2 + 13 + 'px';
    }

    else if (this.popupProps.direction == 'bottom') {
      this.posLeft = coffsetL + curTagWdt + 'px';
      this.posTop = coffsetT - 18 + 'px';

      this.posLeftCon = coffsetL + curTagWdt - this.popupProps.arrowPos + 'px';
      this.posTopCon = coffsetT - this.popupProps.height - 10 + 'px';
    }

    this.updatedStyle = {
      position: 'fixed',
      left: this.posLeftCon,
      top: this.posTopCon,
      width: this.popupProps.width + 'px',
      height: this.popupProps.height + 'px'
    };

    this.x = parseInt(this.posLeftCon.split('px')[0]);
    this.y = parseInt(this.posTopCon.split('px')[0]);
    this.px = 0;
    this.py = 0;
    this.width = this.popupProps.width;
    this.height = this.popupProps.height;
    this.draggingCorner = false;
    this.draggingWindow = false;
    this.minArea = 20000;

    this.cdr.detectChanges()
  }

  animateHeight = '*';



  area() {
    return this.width * this.height;
  }

  onWindowPress(event: MouseEvent) {
    this.draggingWindow = true;
    this.px = event.clientX;
    this.py = event.clientY;
  }

  topLeftResize(offsetX: number, offsetY: number) {
    this.x += offsetX;
    this.y += offsetY;
    this.width -= offsetX;
    this.height -= offsetY;
  }

  topRightResize(offsetX: number, offsetY: number) {
    this.y += offsetY;
    this.width += offsetX;
    this.height -= offsetY;
  }

  bottomLeftResize(offsetX: number, offsetY: number) {
    this.x += offsetX;
    this.width -= offsetX;
    this.height += offsetY;
  }

  bottomRightResize(offsetX: number, offsetY: number) {
    this.width += offsetX;
    this.height += offsetY;
  }

  onCornerClick(event: MouseEvent, resizer?: Function) {
    this.draggingCorner = true;
    this.px = event.clientX;
    this.py = event.clientY;
    this.resizer = resizer;
    event.preventDefault();
    event.stopPropagation();
  }

  cancelEvent(event) {
    // event.stopPropagation();
    // event.preventDefault();

    // // this.el.nativeElement.querySelectorAll('iframe')[0].classList.add('removeGlobalClick');
    // this.zone.runOutsideAngular(() => {
    //   window.document.addEventListener('mousemove', this.onCornerMove.bind(this));
    // });
  }

  // @HostListener('document:mousemove', ['$event'])
  onCornerMove(event) {

    event.stopPropagation();
    if (this.popupProps.isResize) {
      event.preventDefault();
    }




    if (!this.draggingCorner) {
      return;
    }
    if (this.el.nativeElement.querySelectorAll('.chat-corner-resize')[0]) {

      this.el.nativeElement.querySelectorAll('.chat-corner-resize')[0].style.width = this.width.toString() + 'px';
      this.el.nativeElement.querySelectorAll('.chat-corner-resize')[0].style.height = this.height.toString() + 'px';
    }
    let offsetX = event.clientX - this.px;
    let offsetY = event.clientY - this.py;

    let lastX = this.x;
    let lastY = this.y;
    let pWidth = this.width;
    let pHeight = this.height;

    this.resizer(offsetX, offsetY);
    if (this.area() < this.minArea) {
      this.x = lastX;
      this.y = lastY;
      this.width = pWidth;
      this.height = pHeight;
    }
    this.px = event.clientX;
    this.py = event.clientY;

  }

  @HostListener('document:mouseup', ['$event'])
  onCornerRelease(event) {
    event.stopPropagation();
    event.preventDefault();

    if (this.el.nativeElement.querySelectorAll('.chat-corner-resize')[0]) {
      this.el.nativeElement.querySelectorAll('.chat-corner-resize')[0].style.width = '16px';
      this.el.nativeElement.querySelectorAll('.chat-corner-resize')[0].style.height = '16px';

    }

    var globalPopupElem = this.el.nativeElement.querySelectorAll('.globalpopup');
    if (this.popupProps.isResize == true) {
      localStorage.savepopupWidth = parseInt((globalPopupElem[0].style.width).split('px')[0]);
      localStorage.savepopupHeight = parseInt((globalPopupElem[0].style.height).split('px')[0]);
    }
    if (this.popupProps.loadDirective == SmartviewComponent || this.popupProps.loadDirective == PageEnrichmentsComponent || this.popupProps.loadDirective == MiniBookComponent || this.popupProps.loadDirective == ExportviewComponent) {
      this.draggingWindow = false;
      this.draggingCorner = false;

      if (event.target.className.indexOf('globalpopupMain') >= 0) {
        this.hidepopupFromMindmap(event);
      }

    }

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/globalpopup/globalpopup.component.ts